export default __webpack_public_path__ + "static/media/system-ios.png";